import React from 'react';
import { Section, FadeIn } from './Shared';
import { TestimonialCard } from './SocialProof';
export const MoreSocialProof = () => {
  const testimonials = [{
    quote: 'Compré un domingo a la noche. El lunes entré al estudio con el plan exacto de la clase GAP. Las fichas del Tomo 2 son exactamente lo que necesitaba para mis grupos mixtos. Nunca más improviso.',
    name: 'Sofía M.',
    location: 'Buenos Aires',
    role: 'Instructora de GAP en Estudio Propio'
  }, {
    quote: 'El Tomo 5, el de GAP Terapéutico, me cambió todo. El primer mes, alumnas que llevaban meses estancadas mejoraron visiblemente. El protocolo para adultas mayores me da la tranquilidad que antes no tenía.',
    name: 'Carolina R.',
    location: 'Rosario',
    role: 'Instructora en Centro de Adultos Mayores'
  }, {
    quote: 'El banco de 100 ejercicios es único en el mercado. Fichas listas para usar, con errores frecuentes y variantes. Antes tardaba horas armando una clase. Ahora abro el PDF y en 5 minutos tengo todo listo.',
    name: 'Valentina F.',
    location: 'Córdoba',
    role: 'Instructora de GAP Grupal e Individual'
  }, {
    quote: 'Las fichas de clase imprimibles del Bono 1 eliminaron el problema del grupo heterogéneo. Ahora muestro las 3 versiones de cada ejercicio y cada alumna elige la que le corresponde.',
    name: 'Luciana P.',
    location: 'Tucumán',
    role: 'Instructora Particular y en Gimnasio'
  }, {
    quote: 'La tasa de abandono de mis grupos bajó muchísimo. Solo aplicando el sistema de progresión de 90 días y la variedad de los 6 tomos. Las alumnas ahora quieren venir porque siempre hay algo nuevo.',
    name: 'Marcela G.',
    location: 'Mendoza',
    role: 'Instructora de GAP Online y Presencial'
  }, {
    quote: 'El Kit de Bienvenida del Bono 6 me salvó de perder alumnas nuevas. Ahora sé exactamente qué darle a cada alumna el primer día. Mi tasa de retención subió de manera notable.',
    name: 'Laura V.',
    location: 'Santa Fe',
    role: 'Instructora de GAP en Estudio Propio'
  }, {
    quote: 'La Academia GAP Digital me abrió un mundo que no sabía que existía. En 30 días lancé mi primer programa online y recuperé la inversión en la primera semana.',
    name: 'Ana R.',
    location: 'Salta',
    role: 'Instructora en Centro de Salud'
  }];
  return <Section bg="cream" data-id="element-140">
      <div className="text-center mb-6 md:mb-12" data-id="element-141">
        <h2 className="text-2xl md:text-4xl font-extrabold text-charcoal" data-id="element-142">
          Lo que dicen las instructoras que ya usan GAP 360:
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 max-w-6xl mx-auto" data-id="element-143">
        {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className={i === 6 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-144">
            <TestimonialCard {...t} data-id="element-145" />
          </FadeIn>)}
      </div>
    </Section>;
};